import { Suspense } from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import {
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import AuthRouter from "./AuthRouter";
import PrivateRouter from "./PrivateRouter";
import storage from "../auth/storage";
import NotFound from "../pages/404Page";

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
  </div>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {!storage.getToken() ? (
                <>
                  <Route path="auth/*" element={<AuthRouter />} />
                  <Route path="/" element={<Navigate to="/auth/login" />} />
                  <Route path="/404" element={<NotFound />} />
                  <Route path="*" element={<Navigate to="/404" />} />
                </>
              ) : (
                <Route path="/*" element={<PrivateRouter />} />
              )}
            </Routes>
          </Suspense>
        }
      />
    </Route>
  )
);

export default router;
